<template>
  <ContainerBreadcrumb>
    <template #default="{ breadcrumbResponse, productResponse }">
      <Breadcrumb
        v-if="breadcrumbResponse && productResponse"
        id="overview"
        :breads="[
          ...breadcrumbResponse.breadcrumb,
          {
            label: productResponse.titles.raw,
            url: route.path,
          },
        ]"
        class="bg-surface-default-low"
        trackingZone="product"
      />
    </template>
  </ContainerBreadcrumb>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'

import Breadcrumb from '~/scopes/navigation/components/Breadcrumb/Breadcrumb.vue'
import ContainerBreadcrumb from '~/scopes/product-core/components/ContainerBreadcrumb/ContainerBreadcrumb.vue'

const route = useRoute()
</script>
